export const ProviderType = { 
  oklo: 'OkloV1', 
  tbo: 'Tbo', 
  illusions: 'Illusions', 
  unknown: 'Unknown' 
};

export const ProviderLabel = { 
  oklo: 'OKLO', 
  tbo: 'TBO', 
  illusions: 'ILLUSIONS' 
};